import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
const Pagination = ({ pageCount, currentPage, setPage, isMobileView, }) => {
    const disabledPrevious = currentPage === 1;
    const disabledNext = currentPage === pageCount;
    const iconStyle = (t, disabled) => ({
        width: { md: '25px' },
        height: { md: '25px' },
        strokeWidth: '1.5',
        color: disabled ? 'grey' : t.portal.courseDeliveryPage.lessonTitle.font.color,
    });
    return (_jsxs(Stack, { spacing: 0.5, direction: "row", sx: { mt: { md: '-8px', xs: '0px' } }, children: [_jsx(Box, { children: _jsxs(Button, { disabled: disabledPrevious, onClick: () => setPage(currentPage - 1), sx: {
                        px: { xs: !isMobileView ? '0' : '', md: 2 },
                        minWidth: !isMobileView ? 'auto' : '',
                    }, children: [_jsx(ArrowBackIcon, { sx: (t) => ({
                                ...iconStyle(t, disabledPrevious),
                                mr: { md: 1, xs: !isMobileView ? '0' : '' },
                            }) }), !isMobileView && (_jsx(Typography, { variant: "caption", className: "lessonTitle", children: "PREV" }))] }) }), _jsx(Box, { children: _jsxs(Button, { disabled: disabledNext, onClick: () => setPage(currentPage + 1), sx: {
                        px: { xs: !isMobileView ? '0' : '', md: 2 },
                        pr: { xs: '0', md: '8px' },
                        minWidth: !isMobileView ? 'auto' : '',
                    }, children: [!isMobileView && (_jsx(Typography, { variant: "caption", className: "lessonTitle", children: "NEXT" })), _jsx(ArrowForwardIcon, { sx: (t) => ({
                                ...iconStyle(t, disabledNext),
                                ml: !isMobileView ? '0' : '',
                            }) })] }) })] }));
};
export default Pagination;
//# sourceMappingURL=Pagination.js.map